import { render, staticRenderFns } from "./Part6.vue?vue&type=template&id=65af15b2&scoped=true"
import script from "./Part6.vue?vue&type=script&lang=js"
export * from "./Part6.vue?vue&type=script&lang=js"
import style0 from "./Part6.vue?vue&type=style&index=0&id=65af15b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af15b2",
  null
  
)

export default component.exports